import * as constants from '../constants';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.uploadRegistryFile.success: {
            return action.payload;
        }

        case constants.uploadRegistryFile.error: {
            return initialState;
        }

        case constants.uploadRegistryFile.try: {
            return {};
        }

        default:
            return state;
    }
}